module.exports = __webpack_public_path__ + "static/media/banner-books.95a7ceb0.png";